import React from 'react'

export const Detail1 = () => {
    return (
        <svg className="datail_1" width="90" height="98" viewBox="0 0 90 98" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M39.9925 97.2783C62.0798 97.2783 79.9851 79.3731 79.9851 57.2858C79.9851 35.1985 62.0798 17.2933 39.9925 17.2933C17.9053 17.2933 0 35.1985 0 57.2858C0 79.3731 17.9053 97.2783 39.9925 97.2783Z" fill="#6C63FF"/>
        <path d="M49.3736 80.9851C71.4608 80.9851 89.3661 63.0798 89.3661 40.9925C89.3661 18.9053 71.4608 1 49.3736 1C27.2863 1 9.38103 18.9053 9.38103 40.9925C9.38103 63.0798 27.2863 80.9851 49.3736 80.9851Z" stroke="#2F2E41" strokeWidth="0.744737" strokeMiterlimit="10"/>
        </svg>
    )
}
